import {Component, Input} from '@angular/core';

@Component({
        selector: 'tfl-warning-block',
        template: `
        <div>
            <div class="title">
                {{ title }}
            </div>
            <div><ng-content></ng-content></div>
        </div>
    `
    }
)
export class WarningBlockComponent {
    @Input('title') title: string = '';
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/modules/components/warning/warning-block.component.ts